/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import {
  Container,
  DualHeadline,
  Headline,
} from './dual-headline-list-css';

const DualHeadlineList = ({ dualHeadlineItems }) => (
  <Container>
    {dualHeadlineItems.map(({ label, firstHeadline, secondHeadline }) => (
      <DualHeadline key={label}>
        <Headline>{firstHeadline}</Headline>
        <Headline>{secondHeadline}</Headline>
      </DualHeadline>
    ))}
  </Container>
);

DualHeadlineList.propTypes = {
  dualHeadlineItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      firstHeadline: PropTypes.string.isRequired,
      secondHeadline: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default DualHeadlineList;
